import { useTranslation } from 'react-i18next'

import { GivingActionsRow } from '@percent/workplace-giving/app/Home/GivingActionsRow/GivingActionsRow'
import type { CampaignGivingActionsProps } from './CampaignGivingActions.types'

const CAMPAIGN_TILES_AMOUNT = 3

export function CampaignGivingActions({ campaignId, targetCountries }: CampaignGivingActionsProps) {
  const { t } = useTranslation()

  return (
    <GivingActionsRow
      campaignId={campaignId}
      title={t('workplace_giving.givingActions.campaignTitle')}
      tilesAmount={CAMPAIGN_TILES_AMOUNT}
      targetCountries={targetCountries}
      layout="carousel"
      includeUnpublished
    />
  )
}
